import clsx from 'clsx'
import React from 'react'
import { Nullable, Image as ImageProps } from '../../common/props'
import { processImageUrl } from '../../utils/image'
import Image from '../Image/Image'
import useStyles from './ProductBadge.styles'
import Icon from '../Icon/Icon'

export type Props = {
  variant?:
    | 'LAVENDER'
    | 'LAVENDER_LARGE'
    | 'STANDARD'
    | 'RED'
    | 'PURPLE'
    | 'PINK'
    | 'LILAC'
    | 'PEACH'
    | 'YELLOW'
    | 'GREEN'
    | 'FF_DEFAULT'
    | 'FF_SMALL'
    | 'FF_MEDIUM'
    | 'FF_LARGE'
    | 'FF_YELLOW_DEFAULT'
    | 'FF_YELLOW_XL'
    | 'DEEP_ROSE'
    | 'FF_GREY'
    | 'FF_SHARP_YELLOW'
    | 'FF_PLUSH_BLUSH'
    | 'FF_LAZY_LIME'
  line1?: string
  line2?: string
  image?: ImageProps
  altText?: string
  small?: boolean
  icon?: ImageProps
}

const ProductBadge = (props: Props) => {
  const { variant, image, line1, line2, altText, small, icon } = props as Nullable<Props>
  const { classes } = useStyles()
  const variantClass = variant?.toUpperCase()
  const showLine2 = !image?.url ? line1 && line2 : !!line2

  return (
    <div
      className={clsx(
        classes.container,
        small && classes.containerSmall,
        variantClass && classes[variantClass as keyof typeof classes]
      )}
    >
      {icon && (
        <Image imageUrl={icon.url} altText={icon?.altText ?? ''} className={classes.icon} width={'20'} height={'19'} />
      )}
      {line1 && <div className={classes.textLine1}>{line1}</div>}
      {showLine2 && <div className={classes.textLine2}>{line2}</div>}
      {image && image.url && (
        <Image
          imageUrl={image.url.startsWith('http') ? processImageUrl(image.url, { w: small ? 96 : 208 }) : image.url}
          altText={altText || 'Logo'}
          className={classes.image}
          width={small ? '96' : '208'}
          height={small ? '96' : '208'}
          loading="lazy"
        />
      )}
    </div>
  )
}

export default ProductBadge
